var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  관리자 체험 모드로 연결중입니다.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }